import React from "react";
import { Check, ChevronLeft, Save } from "lucide-react";

const defaultCompletionItems = [
  { label: "Basic Info", tone: "danger" },
  { label: "Course Overview", tone: "success" },
  { label: "Learning Outcomes", tone: "danger" },
  { label: "Course Modules", tone: "warning" },
  { label: "Course Materials", tone: "warning" },
];

const toneStyles = {
  danger: "bg-[#FEE2E2] text-[#991B1B]",
  success: "bg-[#DCFCE7] text-[#166534]",
  warning: "bg-[#FEF9C3] text-[#854D0E]",
};

const completionStatusIcons = {
  danger: (
    <span className="inline-flex h-3 w-3 items-center justify-center rounded-full border border-current text-[10px] leading-none">
      !
    </span>
  ),
  success: (
    <span className="inline-flex h-3 w-3 items-center justify-center rounded-full border border-current">
      <Check size={14} strokeWidth={2.5} />
    </span>
  ),
  warning: (
    <span className="inline-flex h-3 w-3 items-center justify-center rounded-full border border-current text-[10px] leading-none">
      !
    </span>
  ),
};

const CourseCompletionSection = ({
  progress = 65,
  onBack,
  completionItems = defaultCompletionItems,
  hasChanges = false,
  onSave,
  isSaving = false,
}) => {
  return (
    <>
      <div
        className="bg-[#ffff] sticky top-[97px] z-40 pt-4 pb-4"
      >
        <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
          <div className="flex items-start gap-3">
            <button
              type="button"
              aria-label="Go back"
              onClick={onBack}
              className="shrink-0 rounded-full border border-[#E5E7EB] bg-white p-2 shadow-[0_1px_2px_#0000000D]"
            >
              <ChevronLeft size={22} />
            </button>

            <div className="min-w-0">
              <h2 className="text-xl font-bold text-[#1F2937] sm:text-2xl">
                Course Details
              </h2>
              <p className="text-sm text-[#6B7280]">
                Edit and manage course information
              </p>
            </div>
          </div>
          {hasChanges && (
            <button
              type="button"
              onClick={onSave}
              disabled={isSaving}
              className="inline-flex h-10 items-center justify-center gap-1.5 rounded bg-[#923D8C] px-5 text-sm text-white shadow-[0_1px_2px_#0000000D] transition hover:opacity-95 sm:h-11 sm:text-base"
            >
              <Save size={16} />
              <span>{isSaving ? "Saving..." : "Save Changes"}</span>
            </button>
          )}
        </div>
      </div>

      <div className="mt-6 rounded-xl border border-[#E5E7EB] bg-white p-4 shadow-[0_1px_2px_#0000000D] sm:mt-8">
        <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
          <span className="text-base text-[#1F2937] sm:text-lg">
            Course Completion
          </span>
          <span className="text-sm text-[#A14598]">{progress}% Complete</span>
        </div>

        <div className="mt-2 h-2.5 overflow-hidden rounded-full bg-[#E5E7EB]">
          <div
            className="h-full rounded-full bg-[#9E4296]"
            style={{ width: `${progress}%` }}
          />
        </div>

        <div className="mt-4 flex flex-wrap gap-2">
          {completionItems.map((item) => (
            <span
              key={item.label}
              className={`inline-flex max-w-full items-center gap-1 rounded-full px-3 py-1 text-xs ${toneStyles[item.tone]}`}
            >
              {completionStatusIcons[item.tone]}
              <span className="truncate">{item.label}</span>
            </span>
          ))}
        </div>
      </div>
    </>
  );
};

export default CourseCompletionSection;
